import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetOrCreateDocumentFromSource } from "services/documents";
import { useContext } from "react";
import { CurrentUserContext } from "components/context/RequireAuth";
import Loading from "components/common/Loading";

export default ({ mode }: { mode: "open" | "create" }) => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const currentUser = useContext(CurrentUserContext);

  const { request: getOrCreateRequest } = useGetOrCreateDocumentFromSource(
    (r) => {
      if (r.document?.ref) {
        navigate(`/documents/${r.document.ref}`);
      }
    },
  );

  useEffect(() => {
    if (!uuid || !currentUser) return;

    getOrCreateRequest({
      sourceDocumentUUID: uuid,
      forceCreate: mode === "create",
    });
  }, [uuid, currentUser, mode]);

  return <Loading />;
};
